export const FABER_PREFIX = '/v1/labs/'
export const VERSION_ONE_API_PREFIX = '/v1/labs/orbit'
export const PAYMENT_API_PREFIX = '/v1/global/pay'
export const B2B_API_PREFIX = '/v1/b2b/admin'

// temp fix before confirmation of role options
export const CUSTOMER_ROLE_OPTIONS = ['owner', 'admin']
export const OPS_ROLE_OPTIONS = ['opsowner', 'ops', 'opsviewer', 'external']
export const EXTERNAL_VENDOR_OPTIONS = ['wegopro', 'mobicom']
